import { PaymentByProps } from "_interfaces/_common/payment";
import { PaymentMethodModel } from "_models/data/data.paymentMethod.model";
import { ApplyCouponModel } from "_models/data/payment/data.applyCoupon.model";
import { WalletPaymentModel } from "_models/data/wallet/data.walletPayment.model";
import { isValidPhone, isValidPin } from "functions/validators";

export const validatePaymentMethod = (
  DATA: PaymentMethodModel,
  paymentBy: PaymentByProps | ""
) => {
  let valid = true;
  let errors = [{ name: "", error: "" }];

  if (paymentBy === "momo") {
    if (!DATA?.momoPhoneNumber?.trim()) {
      valid = false;
      errors.push({
        name: "momoPhoneNumber",
        error: "Enter your Momo phone number",
      });
    }

    if (DATA?.momoPhoneNumber?.trim() && !isValidPhone(DATA.momoPhoneNumber)) {
      valid = false;
      errors.push({
        name: "momoPhoneNumber",
        error: "Invalid phone number.",
      });
    }
  }

  if (paymentBy === "airtelMoney") {
    if (!DATA?.airtelMOMOPhone?.trim()) {
      valid = false;
      errors.push({
        name: "airtelMOMOPhone",
        error: "Enter your Airtel Momo phone number",
      });
    }

    if (DATA?.airtelMOMOPhone?.trim() && !isValidPhone(DATA.airtelMOMOPhone)) {
      valid = false;
      errors.push({
        name: "airtelMOMOPhone",
        error: "Invalid phone number.",
      });
    }
  }

  return { valid, errors };
};

export const validateWalletPaymentSubmit = (DATA: WalletPaymentModel) => {
  let valid = true;
  let errors = [{ name: "", error: "" }];

  if (!DATA.PIN?.trim()) {
    valid = false;
    errors.push({
      name: "PIN",
      error: "PIN is required",
    });
  }

  if (DATA.PIN?.trim() && !isValidPin(DATA.PIN)) {
    valid = false;
    errors.push({
      name: "PIN",
      error: "Invalid PIN",
    });
  }

  return { valid, errors };
};

export const validateApplyCoupon = (DATA: ApplyCouponModel) => {
  let valid = true;
  let errors = [{ name: "", error: "" }];

  const couponRegex = /^[a-zA-Z0-9-]+$/;

  if (!DATA?.coupon?.trim()) {
    valid = false;
    errors.push({
      name: "coupon",
      error: "Enter coupon code",
    });
  } else if (DATA?.coupon.length < 4 || DATA.coupon.length > 10) {
    valid = false;
    errors.push({
      name: "coupon",
      error: "Invalid coupon code",
    });
  } else if (!couponRegex.test(DATA?.coupon)) {
    valid = false;
    errors.push({
      name: "coupon",
      error: "Invalid coupon code",
    });
  }

  return { valid, errors };
};
